export const LESSON_PLAYER_ROUTES = {
    COURSE_STREAM_SHOW: { path: '/course/:streamId/chapter/:chapterIndex/lesson/:lessonId/show' },
    STREAM_SHOW: { path: '/stream/:streamId/chapter/:chapterIndex/lesson/:lessonId/show' },
    LESSON_TITLE_SHOW: { path: '/lesson/:lessonTitle/show/:lessonId' },
    LESSON_TITLE: { path: '/lesson/:lessonTitle/:lessonId' },
    LESSON_MODE_TITLE: { path: '/lesson/:mode/:lessonTitle/:lessonId' },
    LESSON_ID: { path: '/lesson/:lessonId' },
    PRACTICE_SHOW: { path: '/practice/show/:courseOrLesson/:contentItemId' },
};
